__turbopack_context__.v({
  "actions": "WContactForm-module__Pmkuoq__actions",
  "fieldError": "WContactForm-module__Pmkuoq__fieldError" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["errorText"],
  "fieldRow": "WContactForm-module__Pmkuoq__fieldRow",
  "fieldsGrid": "WContactForm-module__Pmkuoq__fieldsGrid",
  "form": "WContactForm-module__Pmkuoq__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "root": "WContactForm-module__Pmkuoq__root",
});
